<template>
    <div class="app-container">
        <template v-if="showOriginal">
            <Auth v-if="!isAuthenticated"/>
            <Base v-if="isAuthenticated"/>
        </template>

        <OnlineDossier v-if="isOnlineDossier"/>
        <OnlineProjectDossier v-if="isOnlineProjectDossier"/>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Auth from '@/views/layouts/Auth'
	import Base from '@/views/layouts/Base'
	import OnlineDossier from '@/views/layouts/OnlineDossier'
	import OnlineProjectDossier from '@/views/layouts/OnlineProjectDossier'

	export default {
		components: { Auth, Base, OnlineDossier, OnlineProjectDossier },

		computed: {
			...mapGetters([
				'isAuthenticated',
			]),

			showOriginal () {
				if (this.$route.meta.onlineDossier || this.$route.meta.onlineProjectDossier) {
					return false
				}

				return true
			},

			isOnlineDossier () {
				return this.$route.meta.onlineDossier ? this.$route.meta.onlineDossier : false
			},

			isOnlineProjectDossier () {
				return this.$route.meta.onlineProjectDossier ? this.$route.meta.onlineProjectDossier : false
			},
		},

		data () {
			return {}
		},
	}
</script>